import React, { useState } from "react";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";

import Calendar from "app/Components/Calendar/Calendar";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import { Modal } from "react-bootstrap";
import { formatDDMMYYYYbyYYYYMMDD } from "app/_helpers/helper";
import { useEffect } from "react";
import { getAllTrainingBatches } from "app/_services/ehs/ehsTrainingServices";
import { Link } from "react-router-dom";
import { ACTIVE_MODULE } from "app/_constants/constant";

const EventInfoModal = ({ title, start, show, onHide, form }) => (
  <Modal className="calenderModel" show={show} onHide={onHide}>
    <Modal.Header closeButton className="bg-primary text-white">
      <Modal.Title>Batch Details</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className="calPopupRow">
        <label className="mr-2">Center Name</label>
        <span>{form?.centerName}</span>
      </div>
      <div className="calPopupRow">
        <label className="mr-2">Center Code</label>
        <span>{form?.centerCode}</span>
      </div>
      <div className="calPopupRow">
        <label className="mr-2">Area of Operation</label>
        <span>{form?.areaName || form?.area}</span>
      </div>
      <div className="calPopupRow">
        <label className="mr-2">Training ID</label>
        <span>{form?.trainingId}</span>
      </div>
      <div className="calPopupRow">
        <label className="mr-2">Batch ID</label>
        <Link
          to={`/health-safety-and-environment/training-management/assign?tab=6&selectedBatchId=${form?.id}`}
        >
          <span>{form?.batchId}</span>
        </Link>
      </div>
      <div className="calPopupRow">
        <label className="mr-2">Duration (Days)</label>
        <span>{form?.duration}</span>
      </div>
      <div className="calPopupRow">
        <label className="mr-2">Date of Training</label>
        <span>{formatDDMMYYYYbyYYYYMMDD(form?.trainingDate)}</span>
      </div>
      <div className="calPopupRow">
        <label className="mr-2">Training Category</label>
        <span>{form?.trainingCategoryName}</span>
      </div>
      <div className="calPopupRow">
        <label className="mr-2">Training Sub Category</label>
        <span>{form?.trainingSubCategoryName}</span>
      </div>
    </Modal.Body>
  </Modal>
);

function Event({ event, timeText }) {
  const [show, setShow] = useState(false);

  const onHide = () => setShow(false);

  return (
    <>
      <div onClick={() => setShow(true)} className="w-100 pointer bg-primary">
        <span style={{ height: 10, width: 15 }} className={`mr-2`} />
        {/* <b className="mr-1">{timeText.toUpperCase()}M</b> */}
        <span className={`pl-1`}>{event.title}</span>
      </div>
      {show && <EventInfoModal show={show} onHide={onHide} {...event.extendedProps} />}
    </>
  );
}

function renderEventContent({ event, timeText }) {
  return <Event event={event} timeText={timeText} />;
}

function TrainingCalendar({
  match: {
    params: { siteId },
  },
}) {
  const [events, setEvents] = useState([]);

  const apiFilter = siteId ? "filter[siteId]=" + siteId : "";

  useEffect(() => {
    getAllTrainingBatches(apiFilter).then((response) => {
      setEvents(
        response.data.map((row) => ({
          id: row.id.toString(),
          title: row.centerName,
          start: row.trainingDate,
          extendedProps: {
            title: row.title,
            start: row.trainingDate,
            form: row,
          },
        }))
      );
    });
  }, [apiFilter]);

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Training Management",
            path: "/health-safety-and-environment/training-management",
          },
          { name: "Calendar" },
        ]}
        module={ACTIVE_MODULE.training}
      />
      <div className="card p-3">
        {/* <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "VFL",
            path: "/health-safety-and-environment/vfl",
          },
          { name: "Calendar" },
        ]}
      /> */}
        <div className="simple-card-title cardCustomHeader">
          <h3 class="text-capitalize mb-0">Training Calendar</h3>
          <BackBtn url={"/health-safety-and-environment/training-management"} />
        </div>
        <div className="mt-3">
          <div className="ehsFormWrapper">
            <Calendar events={events} renderEventContent={renderEventContent} />
          </div>
        </div>
      </div>
    </>
  );
}

export default TrainingCalendar;
